import { Link } from 'react-router-dom';
import { Menu, X, ExternalLink } from 'lucide-react';
import { useState } from 'react';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const amazonStoreUrl = "https://www.amazon.com/stores/TRENDO/page/3D435283-278E-44B3-83C7-66C5C0BCC5C0?lp_asin=B0DRT7VDLX&ref_=ast_bln&store_ref=bl_ast_dp_brandLogo_sto";

  const navItems = [
    { name: 'Home', path: '#home' },
    { name: 'About', path: '#about' },
    { name: 'Services', path: '#services' },
    { name: 'Testimonials', path: '#testimonials' },
    { name: 'FAQ', path: '#faq' },
    { name: 'Contact', path: '#contact' },
  ];

  const handleNavClick = (e, path) => {
    e.preventDefault();
    setIsOpen(false);
    const element = document.querySelector(path);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav className="glass sticky top-0 z-50" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="font-heading font-bold text-2xl text-slate-900" data-testid="logo">
            Snappadeal
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6">
            {navItems.map((item) => (
              <a
                key={item.path}
                href={item.path}
                onClick={(e) => handleNavClick(e, item.path)}
                className="text-slate-600 hover:text-slate-900 font-medium transition-colors duration-200 text-sm whitespace-nowrap"
                data-testid={`nav-${item.name.toLowerCase()}`}
              >
                {item.name}
              </a>
            ))}
            <div className="flex items-center gap-3 ml-2">
              <a
                href={amazonStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 bg-[#FF9900] text-slate-900 hover:bg-[#FFB84D] rounded-full px-4 py-2 font-medium transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5 text-sm whitespace-nowrap"
                data-testid="nav-amazon-button"
              >
                Shop TRENDO
                <ExternalLink size={14} />
              </a>
              <a
                href="#contact"
                onClick={(e) => handleNavClick(e, '#contact')}
                className="bg-[#10B981] text-white hover:bg-[#059669] rounded-full px-4 py-2 font-medium transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5 text-sm whitespace-nowrap"
                data-testid="nav-cta-button"
              >
                Contact
              </a>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-slate-900"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="lg:hidden pb-6" data-testid="mobile-menu">
            {navItems.map((item) => (
              <a
                key={item.path}
                href={item.path}
                onClick={(e) => handleNavClick(e, item.path)}
                className="block py-3 text-slate-600 hover:text-slate-900 font-medium"
                data-testid={`mobile-nav-${item.name.toLowerCase()}`}
              >
                {item.name}
              </a>
            ))}
            <a
              href={amazonStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 mt-4 bg-[#FF9900] text-slate-900 hover:bg-[#FFB84D] rounded-full px-6 py-3 font-medium"
              data-testid="mobile-amazon-button"
            >
              Shop TRENDO on Amazon
              <ExternalLink size={16} />
            </a>
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="block mt-2 bg-[#10B981] text-white text-center hover:bg-[#059669] rounded-full px-6 py-3 font-medium"
              data-testid="mobile-cta-button"
            >
              Get in Touch
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};
